/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainEntitiesDocumentsDocument } from './FxIdDomainEntitiesDocumentsDocument';
import {
    FxIdDomainEntitiesDocumentsDocumentFromJSON,
    FxIdDomainEntitiesDocumentsDocumentFromJSONTyped,
    FxIdDomainEntitiesDocumentsDocumentToJSON,
    FxIdDomainEntitiesDocumentsDocumentToJSONTyped,
} from './FxIdDomainEntitiesDocumentsDocument';

/**
 * 
 * @export
 * @interface FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse
 */
export interface FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse {
    /**
     * 
     * @type {Array<FxIdDomainEntitiesDocumentsDocument>}
     * @memberof FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse
     */
    Documents: Array<FxIdDomainEntitiesDocumentsDocument>;
}

/**
 * Check if a given object implements the FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse interface.
 */
export function instanceOfFxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse(value: object): value is FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse {
    if (!('Documents' in value) || value['Documents'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseFromJSON(json: any): FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse {
    return FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Documents': ((json['Documents'] as Array<any>).map(FxIdDomainEntitiesDocumentsDocumentFromJSON)),
    };
}

export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseToJSON(json: any): FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse {
    return FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseToJSONTyped(value?: FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Documents': ((value['Documents'] as Array<any>).map(FxIdDomainEntitiesDocumentsDocumentToJSON)),
    };
}

